import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/modules/auth/presentation/hooks/use-auth';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import { rankingContainer } from '../../di/container';

/**
 * A posição desta pessoa no ranking da edição. Leva a data do gabarito na
 * chave: reenviar o gabarito precisa refazer a posição, e com a data junto a
 * consulta antiga não é reaproveitada.
 */
export function useRanking(gabaritoSubmittedAt: string | undefined) {
  const { user } = useAuth();
  const { id, edition } = useTenant();

  return useQuery({
    queryKey: ['ranking', user?.id, id, edition.year, gabaritoSubmittedAt],
    queryFn: () => rankingContainer.repository.getMine(id, edition.year),
    enabled: user?.hasProfile === true,
  });
}
